export const getFullName = (name?: string, surname?: string) => {
  return [name, surname].filter(Boolean).join(' ')
}
